import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../configs/translations'
import { IMdfActivityOutcomeForm } from '../../lib'
import { EMdfOutcomeValueType } from '../../model/mdfOutcomeItem'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.detailsModal

export interface IMdfOutcomeMetricField {
  field: keyof Pick<
    IMdfActivityOutcomeForm,
    'funnelSizeUsd' | 'leads' | 'conversionRate' | 'attendance' | 'estimatedSalesUsd'
  >
  labelKey: string
  min?: number
  max?: number
}

export const MDF_OUTCOME_METRIC_FIELDS: IMdfOutcomeMetricField[] = [
  { field: 'funnelSizeUsd', labelKey: KEYS.fields.funnelSize, min: 0 },
  { field: 'conversionRate', labelKey: KEYS.fields.conversionRate, min: 0, max: 1 },
  { field: 'estimatedSalesUsd', labelKey: KEYS.fields.estimatedSales, min: 0 },
  { field: 'leads', labelKey: KEYS.fields.leads, min: 0 },
  { field: 'attendance', labelKey: KEYS.fields.attendance, min: 0 },
]

export interface IMdfOutcomeValueTypeConfig {
  value: EMdfOutcomeValueType
  labelKey: string
  icon: string
}

const OUTCOME_KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.outcomes

export const MDF_OUTCOME_VALUE_TYPES: IMdfOutcomeValueTypeConfig[] = [
  {
    value: EMdfOutcomeValueType.Financial,
    labelKey: OUTCOME_KEYS.valueTypes.financial,
    icon: 'kbase kbase-chart',
  },
  {
    value: EMdfOutcomeValueType.Number,
    labelKey: OUTCOME_KEYS.valueTypes.number,
    icon: 'kbase kbase-editor-ol',
  },
  {
    value: EMdfOutcomeValueType.Percentage,
    labelKey: OUTCOME_KEYS.valueTypes.percentage,
    icon: 'kbase kbase-lvl-poll',
  },
  {
    value: EMdfOutcomeValueType.FreeText,
    labelKey: OUTCOME_KEYS.valueTypes.freeText,
    icon: 'kbase kbase-omni-text',
  },
]
